import axios from 'axios';
import API_BASE_URL from '../config/api';
import authService from './authService';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const userService = {
  async updateProfile(userId, payload) {
    try {
      const response = await api.put(`/users/${userId}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update profile';
    }
  }
};

export default userService;
